import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IClass } from '@/interfaces/general';
import styles from './MemberId.module.scss'
import { copyTextToClipboard } from '@/utils/app';

interface MemberIdProps extends IClass {
  id: string
}

const MemberId = (
  {
    className,
    id,
  }: MemberIdProps) => {
  const copy = () => {
    copyTextToClipboard(id)
  }
  return <div
    className={classNames(styles.box, className)}
    onClick={copy}
  >
    <FormattedMessage id="PROFILE.MEMBERID">
      {txt => <span className={styles.title}>{txt}</span>}
    </FormattedMessage>
    <span className={styles.memberId}>
      {id}
      <i
        className={classNames('chat-copy', styles.copy)}
        data-tooltip="copy"
      />
    </span>
  </div>
}

export default MemberId
